import React from 'react';
import { Typography, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import herobackground from '../assets/images/herobackground.jpg'


const useStyles = makeStyles(theme => ({
    root: {
        padding: "10px"
    },
    herotext: {
        textDecoration: 'none',
        color: 'Blue',
    },
}));

function CustomHero() {
    const classes = useStyles();

    return (
        <Container maxWidth="lg" style={{ backgroundImage : `url(${herobackground})`, height: '40vh' }}>
            <div className={classes.root}>
                <Typography component="div" className={classes.herotext} variant="h3" align="center">
                    IT Hosting and Managed Services
                </Typography>

                <Typography component="div" className={classes.herotext} variant="h5" align="center" gutterBottom>
                    (Outsourcing)
                </Typography>
            </div>
        </Container>
    );
}

export default CustomHero;